
<ng-container *ngFor="let info of extraInformationVM; index as position; trackBy: trackById; last as isLast">
  <div class="extraInformation__cont" [class.last]="isLast">
    <app-ds-accordion
      [type]="accordionType"
      [size]="accordionSize"
      [extend]="height[position]"
      [text]="info.Title || (('PASSENGER' | transloco) + ' ' + (position + 1))"
      (clickEvent)="resetHeight($event, position)">
      <div class="extraInformation__form">
        <app-extra-information-form
          [addDynamicElement]="addDynamicElement"
          [info]="info"
          [key]="info.Title || (('PASSENGER' | transloco) + ' ' + (position + 1))"
          [validation]="validation"
          [isSubmitted]="isSubmitted"
          [position]="position"
          [isMobile]="isMobile"
          [resetValues]="resetValues[position]"
          (shareFormHeight)="getHeight($event, position)">
        </app-extra-information-form>
      </div>
    </app-ds-accordion>
    <ng-container *ngIf="formIsInvalid(position)">
      <div class="extraInformation__form-error">
        <app-ds-typography
          [size]="fontSize.XXXS"
          [color]="fontColor.Warning"
          [fontFamily]="fontFamily.Regular"
          [text]="'BOOKING_MODULE.ADDITIONAL_INFORMATION.MANDATORY_ALERT' | transloco">
        </app-ds-typography>
      </div>
    </ng-container>
  </div>
</ng-container>